/* import __COLOCATED_TEMPLATE__ from './checklist-accordion.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { InstantAccessRequirementItem, RequestPinwheelLinkTokenRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/instant_access/instant_access_service';
import { action } from '@ember/object';
// eslint-disable-next-line dashboard/use-utilities-window
import theWindow from 'ember-window-mock';
import { captureException } from '@sentry/browser';
import { tracked } from '@glimmer/tracking';
import { feature } from '@square/ember-features/macros';
let BankingInstantPayoutsChecklistAccordion = (_dec = service('bbfrontend/v1/instant-access'), _dec2 = feature('banking/should_use_pinwheel_dds_for_instant_payouts'), (_class = class BankingInstantPayoutsChecklistAccordion extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "applicationRouter", _descriptor, this);
    _initializerDefineProperty(this, "bBFrontendV1InstantAccessService", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _initializerDefineProperty(this, "shouldShowPinwheelDisclaimerModal", _descriptor4, this);
    _initializerDefineProperty(this, "shouldUsePinwheelDDSForInstantPayouts", _descriptor5, this);
  }
  get directDepositsSetupRequirementType() {
    return InstantAccessRequirementItem.Type.DIRECT_DEPOSITS_SETUP;
  }
  get doorDashPlatformLabel() {
    return 'DoorDash';
  }
  shouldShowPinwheelDirectDepositSwitchExperience(requirementItemType, platformLabel) {
    return this.shouldUsePinwheelDDSForInstantPayouts && requirementItemType === InstantAccessRequirementItem.Type.DIRECT_DEPOSITS_SETUP && platformLabel === this.doorDashPlatformLabel // Pinwheel is only supported for the DoorDash platform at the moment
    ;
  }
  handleClickPropagation(e) {
    e.stopPropagation();
  }
  onChecklistAccordionRowClick(requirementItem, accordionItem) {
    if (requirementItem.directUrl) {
      theWindow.open(requirementItem.directUrl.urlString, '_blank', 'noopener noreferrer');
    }
    if (requirementItem.inAppFlow === InstantAccessRequirementItem.InAppFlow.CHECKING_ONBOARDING) {
      this.applicationRouter.transitionTo('checking', {
        queryParams: {
          unitToken: this.args.unitToken,
          start: 'true',
          returnTo: encodeURIComponent(`ember://instant-payouts-settings?unitToken=${this.args.unitToken}`)
        }
      });
    } else if (requirementItem.inAppFlow === InstantAccessRequirementItem.InAppFlow.CHECKING_ACCOUNT_NUMBERS_MODAL) {
      if (!this.shouldShowPinwheelDirectDepositSwitchExperience(requirementItem.type, accordionItem.platformLabel)) {
        this.args.onClickDirectDepositItem(requirementItem, accordionItem);
      } else {
        this.openPinwheelDisclaimerModal();
      }
    }
  }
  openPinwheelDisclaimerModal() {
    this.shouldShowPinwheelDisclaimerModal = true;
  }
  openPinwheelLinkAndCloseAuthModal() {
    const linkTokenPromise = this.requestPinwheelLinkToken();
    linkTokenPromise.then(linkToken => {
      const options = {
        linkToken,
        onSuccess: () => {},
        onEvent: (eventName, payload) => {
          this.dataApi.track('Instant Payouts Pinwheel Direct Deposit Switch Link Event', {
            eventName,
            payload
          });
        }
      };
      window.Pinwheel.open(options);
    });
    this.shouldShowPinwheelDisclaimerModal = false;
  }
  async requestPinwheelLinkToken() {
    try {
      const response = await this.bBFrontendV1InstantAccessService.client.requestPinwheelLinkToken(RequestPinwheelLinkTokenRequest.create({
        unitToken: this.args.unitToken
      }));
      return response.success?.linkToken;
    } catch {
      captureException('Error attempting to call RequestPinwheelLinkToken');
      return undefined;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bBFrontendV1InstantAccessService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "shouldShowPinwheelDisclaimerModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "shouldUsePinwheelDDSForInstantPayouts", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleClickPropagation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClickPropagation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChecklistAccordionRowClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChecklistAccordionRowClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openPinwheelDisclaimerModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openPinwheelDisclaimerModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openPinwheelLinkAndCloseAuthModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openPinwheelLinkAndCloseAuthModal"), _class.prototype)), _class));
export { BankingInstantPayoutsChecklistAccordion as default };